<style scoped lang="less">
#map{width: 100%;height: 100%;}
#map3d{position: relative;width:100%;height:100%}

</style>

<template>
  <div>
    <!-- <div id="map" class="map" v-loading="loading"></div> -->
    <div id="map3d"  element-loading-text="加载中" element-loading-background="rgba(30,59,91, 0.8)"></div>
  </div>
</template>

<script>
// import 'ol/ol.css'
// import Map from 'ol/Map'
// import TileLayer from 'ol/layer/Tile'
// import View from 'ol/View'
// import XYZ from 'ol/source/XYZ'
// import DragPan from 'ol/interaction/DragPan'
// import WMTS from 'ol/source/WMTS'
// import WMTSTileGrid from 'ol/tilegrid/WMTS'
import OmpBase from '@/plugins/app/assembly/kyxxyzt/OmpBase'

export default {
  data()
  {
    return {
      Basemap: [],
      loading: false,
      Layernar: [],
      node: []
    }
  },
  mounted()
  {
    this.init()

    // this.$nextTick(() =>
    // {
    //   this.loadModules()
    //   let pan = this.getPan()
    //   pan.setActive(false)//false禁止拖拽，true允许拖拽
    // })
  },
  methods:
  {
    // loadModules()
    // {
    //   let layer1 = new TileLayer({
    //     title: '矢量底图',
    //     source: new XYZ({
    //       url: 'http://t0.tianditu.com/DataServer?T=vec_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
    //     }),
    //     visible: false
    //   })
    //   var layer2 = new TileLayer({
    //     title: '影像底图',
    //     source: new XYZ({
    //       url: 'http://t0.tianditu.com/DataServer?T=img_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
    //     }),
    //     visible: true
    //   })
    //   var layer3 = new TileLayer({
    //     title: '中文注记',
    //     source: new XYZ({
    //       url: 'http://t0.tianditu.com/DataServer?T=cva_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
    //     }),
    //     visible: true
    //   })
    //   var layer4 = new TileLayer({
    //     title: '地形底图',
    //     source: new XYZ({
    //       url: 'http://t0.tianditu.com/DataServer?T=ter_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
    //     }),
    //     visible: false
    //   })
    //   var map = new Map({
    //     target: 'map',
    //     layers: [layer1, layer2, layer4, layer3],
    //     overlays: [],
    //     view: new View({
    //       center: [120.91, 7.01],
    //       projection: 'EPSG:4326',
    //       zoom: 4.5
    //     })
    //   })
    //   window.map = map
    //   this.Basemap = [{name: '矢量底图', layer: layer1}, {name: '卫星底图', layer: layer2}, {name: '地形底图', layer: layer4}]
    //   setTimeout(() =>
    //   {
    //     window.map.updateSize()
    //   }, 1000)
    //   //加载arcgis切片图层
    //   let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: 'visible=1 and namec = "东盟地质图"', vals: this.Title}
    //   window.post.getPost(paras).then((ret) =>
    //   {
    //     if (ret[0].filter !== 'WMS')
    //       return false
    //     let layer = ret[0].type.split(':')[1].split('_')[1]
    //     let resolutions = []
    //     if ((ret[0].glid === 914 && ret[0].namec === '柬埔寨矿权') || ret[0].namee === 'Cambodia2')
    //       resolutions = [0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772, 0.0002974141339366386, 0.0001487070669683193, 0.00007435353348415965]
    //     else if (ret[0].glid === 914 && ret[0].namec === '印度尼西亚矿权')
    //       resolutions = [0.03806900914388974, 0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772, 0.0002974141339366386]
    //     else if (ret[0].glid === 914 || ret[0].namee === 'Vietnam1')
    //       resolutions = [0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772, 0.0002974141339366386, 0.0001487070669683193]
    //     else if (ret[0].glid === 870 && ret[0].namec !== '机场')
    //       resolutions = [0.07613801828777948, 0.03806900914388974, 0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772]
    //     else
    //       resolutions = [0.15227603657555896, 0.07613801828777948, 0.03806900914388974, 0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544]
    //     var tileGridWMTS = new WMTSTileGrid({
    //       resolutions: resolutions,
    //       //原点
    //       origin: [-400, 400],
    //       tileSize: 256,
    //       matrixIds: [`${ret[0].type}:0`, `${ret[0].type}:1`, `${ret[0].type}:2`, `${ret[0].type}:3`, `${ret[0].type}:4`, `${ret[0].type}:5`, `${ret[0].type}:6`, `${ret[0].type}:7`]
    //     })
    //     var smOption = {
    //       tileGrid: tileGridWMTS,
    //       matrixSet: ret[0].type,
    //       projection: 'EPSG:4326',
    //       layer: layer,
    //       style: '',
    //       version: '1.0.0',
    //       format: 'image/png',
    //       transition: 0,
    //       opaque: 0,
    //       url: 'http://www.camining.cn/geowebcache/service/wmts'
    //     }
    //     var lyr = new TileLayer({
    //       title: ret[0].namec,
    //       namee: ret[0].name,
    //       source: new WMTS(smOption)
    //     })
    //     window.map.addLayer(lyr)
    //   })
    // },
    //是否开启拖拽地图
    // getPan()
    // {
    //   let pan = null
    //   window.map.getInteractions().forEach(element =>
    //   {
    //     if (element instanceof DragPan)
    //       pan = element
    //   })
    //   return pan
    // },
    init(container)
    {
      this.viewer = new window.cxe.Viewer('map3d', {
        contextOptions: {
          webgl: {
            alpha: true,
            depth: false,
            stencil: true,
            antialias: true,
            premultipliedAlpha: true,
            preserveDrawingBuffer: true,
            failIfMajorPerformanceCaveat: true
          },
          allowTextureFilterAnisotropic: true
        }
      })
      window.Viewer = this.viewer
      this.viewer.scene.globe.depthTestAgainstTerrain = true
      this.vectorLayer = new window.cxe.ImageryLayer('tdt', {
        style: 'img',
        key: '569737ea36171685d686b54ce079a49d',
        show: true
      })
      this.viewer.layers.addImageryLayer(this.vectorLayer)
      this.ompBase = new OmpBase({ viewer: this.viewer })
      this.LoadNoteLayer()
      // 添加经纬度信息
      Viewer.stateBar.enable = true
      // 画点图层
      let pointLayer = new window.cxe.VectorLayer('pointLayer')
      Viewer.layers.addLayer(pointLayer)
      // 画点图层
      let polygonLayer = new window.cxe.VectorLayer('polygonLayer')
      Viewer.layers.addLayer(polygonLayer)
      this.setFlytoPos()
    },
    // 加载天地图注记
    LoadNoteLayer()
    {
      let baseLayerzj = new window.cxe.ImageryLayer('tdt', {
        style: 'cva',
        key: '569737ea36171685d686b54ce079a49d'
      })
      Viewer.layers.addImageryLayer(baseLayerzj)
    },
    // 设置默认飞行经纬度地址
    setFlytoPos(val)
    {
      Viewer.camera.flyTo({
        destination: window.Cesium.Cartesian3.fromDegrees(102.289, 16.284, 1485110),
        duration: 5
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/DigitalScreen/Map.vue